import React from 'react';

export interface LogosGridProps {
  column_count: number;
  scale_on_hover: boolean;
  background_color: string;
  logos: GridLogo[];
}

export const LogosGrid: React.FC<LogosGridProps> = props => {
  return (
    <div
      className={`logos-grid ${props.scale_on_hover ? 'logos-grid--scale-on-hover' : ''}`}
      style={{
        gridTemplateColumns: `repeat(${props.column_count}, 1fr)`,
      }}
    >
      {props.logos.map(logo => (
        <div
          key={logo.title}
          className='logos-grid__logo'
          style={{
            backgroundColor: props.background_color,
          }}
        >
          <img
            src={logo.url}
            alt={logo.alt}
            title={logo.title}
          />
        </div>
      ))}
    </div>
  );
};
